export default __webpack_public_path__ + "static/media/ResidentialHero.2117f205.png";